module.exports = __webpack_public_path__ + "img/p7.776d4af2.png";